/* Componente utilizado para o usuario saber se faz entrega ou retirada no novo checkout */
import { FC, useEffect, useState } from "react";
import "./chooseAddress.css";
import { BsChevronUp, BsChevronDown } from "react-icons/bs";
import InputMask from "react-input-mask";
import { floatToPriceWithoutSpace } from "../../functions/price_functions";
import { usePluginspace } from "../../hooks/usePluginspace";
import { useOrder } from "../../hooks/useOrder";
import { LocationType } from "../../contexts/PluginspaceContext";
import { Input } from "../inputs/inputs";
import { FrenetDeliveryMethodType } from "../../contexts/OrderContext";
import { MainButton } from "../MainButton";
import { AddressMapType } from "../ModalDelivery";
import api from "../../services/api";
import Swal from "sweetalert2";
import { Loading } from "../../components/Loading";
import { FiSearch } from "react-icons/fi";

type Props = {
  deliveryActive: boolean;
  findLocation?: boolean;
  findCep: boolean;
  withDrawValue: number;
  deliveryDrawValue: number;
  setCep: (value: string) => void;
  getStores: (cep: string, location?: MapLocationType) => void;
  findCepDelivery: (value: string) => void;
  cep: string;
  setTypeFreight: (value: string) => void;
  setFreightFind: (value: number) => void;
  typeFreight: string;
  stores: any[];
  frenetMethods: FrenetDeliveryMethodType[];
  config: any;
  getPosition: () => Promise<void>;
  openModal?: boolean;
  setOpenModal?: (value: boolean) => void;
  selectValue?: boolean;
};

type MapLocationType = {
  longitude: number;
  latitude: number;
};

type StoresType = {
  id: number;
  name: string;
  city: string;
  district: string;
  street: string;
  number: string;
  currentBalance: number;
  distance: string;
};

type ModalWithdrawalProps = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  backgroundButton?: string;
  fontButton?: string;
  stores: Array<StoresType>;
};

type AddressLocationType = {
  cep: string;
  city: string;
  district: string;
  extra: string;
  number: string;
  state: string;
  street: string;
};

type LocationResponseType = {
  address: AddressLocationType;
  type: string;
  name: string;
  code: string;
};

const ChooseAddress: FC<Props> = ({
  deliveryActive,
  findLocation,
  findCep,
  stores,
  withDrawValue,
  deliveryDrawValue,
  setCep,
  cep,
  getStores,
  setTypeFreight,
  setFreightFind,
  typeFreight,
  frenetMethods,
  config,
  findCepDelivery,
  getPosition,
  openModal = false,
  setOpenModal,
  selectValue = true,
}) => {
  const [isOpen, setIsOpen] = useState(openModal);
  const [selectedStore, setSelectedStore] = useState<number>();
  const { getLocations, pluginspace, getToken } = usePluginspace();
  const { setType, setOrderAddress, setLocationId } = useOrder();
  const [locations, setLocations] = useState<Array<LocationType>>([]);
  const [loading, setLoading] = useState(false);
  const [valueCep, setValueCep] = useState(0);
  const [totvsMotorAble, setTotvsMotorAble] = useState(false);
  // const [findCep, setFindCep] = useState(false);
  const [labelFree, setLabelFree] = useState("");

  const [position, setPosition] = useState({ latitude: 0, longitude: 0 });

  const [addressMapLocation, setAddressMapLocation] =
    useState<AddressMapType | null>(null);

  useEffect(() => {
    setIsOpen(openModal);
  }, [openModal]);

  useEffect(() => {
    mountChooseAddress();
    setWithdrawLocation();
    getConfigLabelFree();
  }, []);

  async function getConfigLabelFree() {
    if (config?.content?.pdv?.customDeliveryFreeLabel)
      setLabelFree(config.content.pdv.customDeliveryFreeLabel);
  }

  async function mountChooseAddress() {
    try {
      const loc = await getLocations();
      setLocations(loc);
    } catch (error) {
      console.log(error);
    }
  }

  async function setWithdrawLocation() {
    setType("withdraw");
    const store = pluginspace.address;
    const newLocation = await getLocations();
    const loc = newLocation.find(
      (location: LocationResponseType) => location.type == "address"
    );
    const locationWithdraw = newLocation.find(
      (location: LocationResponseType) => location.code == "withdraw"
    );

    if (loc && locationWithdraw) {
      setOrderAddress({
        address: loc.address.street,
        cep: loc.cep,
        state: loc.address.state,
        city: loc.address.city,
        complement: loc.address.extra,
        district: loc.address.district,
        name: store?.name,
        number: loc.address.number,
        reference: "",
        otherPersonToWithdrawal: null,
      });
      setLocationId(locationWithdraw.id);
    }
  }

  async function searchCep() {
    try {
      setLoading(true);
      await findCepDelivery(cep);
      // setFindCep(true);
      if (deliveryActive) {
        setTypeFreight("delivery");
        setFreightFind(deliveryDrawValue);
      }
      setIsOpen(true);
      if (setOpenModal) {
        setOpenModal(true);
      }
    } catch (error) {
      console.log(error);
      // setFindCep(false);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (deliveryActive && findCep && deliveryDrawValue >= 0) {
      setTypeFreight("delivery");
      setFreightFind(deliveryDrawValue);
    }
  }, [deliveryDrawValue, findCep]);

  const searchPosition = async () => {
    try {
      await getPosition();
      setIsOpen(true);
      if (setOpenModal) {
        setOpenModal(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="mainChooseAddress">
      <div className="headerChooseAddress">
        <div className="main">
          <span>Estimativa de Frete</span>
          {isOpen ? (
            <BsChevronDown onClick={() => setIsOpen(false)} />
          ) : (
            <BsChevronUp onClick={() => setIsOpen(true)} />
          )}
        </div>
      </div>
      {isOpen && (
        <>
          {locations.find((loc) => loc.code === "delivery") && (
            <>
              <div className="secondary">
                <span>
                  Digite seu CEP para ver as opções de entrega e retirada
                  disponíveis.
                </span>
              </div>

              <div>
                <div
                  className="cepFind"
                  style={{ flexDirection: findLocation ? "column" : "row" }}
                >
                  <div className="inputTextCEP">
                    <label>CEP:</label>
                    <div className={findLocation ? "container-cep" : ""}>
                      <div className="inputCepWrapper">
                        <InputMask
                          mask="99999-999"
                          className="inputCep"
                          type="text"
                          value={cep}
                          onChange={(value) => {
                            setCep(value.target.value);
                          }}
                          maskPlaceholder="00000-000"
                          onKeyDown={(event) => {
                            if (event.key === "Enter") searchCep();
                          }}
                          style={{ padding: "0.8rem" }}
                        />
                        {/* <div className="icon-search-cep" onClick={searchCep}>
                      <FiSearch size={18} color="#666" />
                    </div> */}
                      </div>
                      {findLocation ? (
                        <div className="button-use-location">
                          <MainButton
                            border={`1px solid ${
                              config?.webappcolor.webappbutton
                                ? config.webappcolor.webappbutton
                                : "#666666"
                            }`}
                            color={
                              config?.webappcolor.webappbutton
                                ? config.webappcolor.webappbutton
                                : "#666666"
                            }
                            backgroundColor="#F5F5F5"
                            text={"Usar localização"}
                            icon={
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 281.16 411.13"
                                fill={
                                  config?.webappcolor.webappbutton
                                    ? config.webappcolor.webappbutton
                                    : "#666666"
                                }
                              >
                                <g>
                                  <g>
                                    <path
                                      className="cls-1"
                                      d="M270.99,126.73c.42,23.17-6.36,44.56-16.23,65.18-15.06,31.45-35.33,59.44-58.01,85.64-15.11,17.45-31.35,33.93-47.27,50.67-5.64,5.93-11.69,5.96-17.49.29-35.28-34.52-67.87-71.28-93.36-113.83-12.19-20.35-22.6-41.58-26.58-65.22-5.99-35.68,2.26-68.39,24.1-96.87C66.99,12.36,108.57-5.55,158.69,1.5c49.9,7.02,84.46,35.71,103.68,82.39,5.62,13.64,8.13,28.06,8.62,42.84ZM184.46,130.71c-.05-24.61-19.54-44.16-43.95-44.08-24.7.07-43.94,19.69-43.84,44.7.09,23.58,20.12,43.27,43.96,43.19,24.2-.08,43.89-19.75,43.84-43.81Z"
                                    />
                                    <path
                                      className="cls-1"
                                      d="M86.65,313.7c-5.29,3.8-10.38,6.75-14.61,10.62-8.92,8.16-8.8,18.7-.02,27,8.46,7.99,18.9,12.27,29.99,14.97,30.28,7.37,60.3,6.98,89.67-4.24,5.49-2.1,10.77-5.34,15.41-9.01,11.5-9.09,11.56-20.93.36-30.33-3.89-3.27-8.42-5.76-13.02-8.84,6.14-6.99,12.19-13.99,18.44-20.81.74-.81,2.75-1.13,3.9-.77,16.59,5.12,32.67,11.39,46.31,22.53,24.42,19.94,24.07,44.28-.83,63.8-16.74,13.12-36.24,20.13-56.61,24.82-49.78,11.47-99.23,10.41-148.07-5.11-15.79-5.01-30.6-12.1-43.02-23.44-6.26-5.71-11.28-12.29-13.44-20.6-3.53-13.55,1.79-24.43,10.94-33.91,11.87-12.31,27.03-19.1,42.66-24.97,11.77-4.42,11.8-4.31,20.07,5.01,3.95,4.45,7.93,8.88,11.88,13.29Z"
                                    />
                                  </g>
                                </g>
                              </svg>
                            }
                            onClick={() => {
                              searchPosition();
                            }}
                          />
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: findLocation ? "0" : "8px" }}>
                  <MainButton
                    text={"Consultar"}
                    onClick={() => {
                      searchCep();
                    }}
                    height={"40px"}
                    bold={"800"}
                    backgroundColor={
                      config?.webappcolor.webappbutton
                        ? config.webappcolor.webappbutton
                        : "#EAEAEA"
                    }
                    color={
                      config?.webappcolor.fontbutton
                        ? config.webappcolor.fontbutton
                        : "#636363"
                    }
                  />
                </div>
              </div>

              {/* Processamento dos métodos de entrega */}
              {deliveryActive && findCep && (
                <>
                  <Input
                    inputAttr={{
                      type: "radio",
                      name: "typeFreight",
                    }}
                    name="typeFreight"
                    label={`${selectValue ? "" : "- "} ${
                      locations.find((loc) => loc.code === "delivery")?.name
                    }: ${
                      deliveryDrawValue === 0 && labelFree
                        ? labelFree
                        : floatToPriceWithoutSpace(deliveryDrawValue)
                    }`}
                    checked={typeFreight === "delivery"}
                    change={() => {
                      setTypeFreight("delivery");
                      setFreightFind(deliveryDrawValue);
                    }}
                    showRadio={selectValue}
                  />
                </>
              )}

              {frenetMethods &&
                frenetMethods.map((frenetMethod) => (
                  <Input
                    inputAttr={{
                      type: "radio",
                    }}
                    name={frenetMethod.ServiceCode}
                    label={`${selectValue ? "" : "- "} ${
                      frenetMethod.ServiceDescription
                        ? frenetMethod.ServiceDescription
                        : frenetMethod.Carrier
                    } (${frenetMethod.DeliveryTime} ${
                      parseInt(frenetMethod.DeliveryTime) > 1 ? "dias" : "dia"
                    } ${
                      parseInt(frenetMethod.DeliveryTime) > 1 ? "úteis" : "útil"
                    }): ${floatToPriceWithoutSpace(
                      parseFloat(frenetMethod.ShippingPrice)
                    )}`}
                    checked={
                      typeFreight === `delivery-${frenetMethod.ServiceCode}`
                    }
                    change={() => {
                      setTypeFreight(`delivery-${frenetMethod.ServiceCode}`);
                      setFreightFind(parseFloat(frenetMethod.ShippingPrice));
                    }}
                    showRadio={selectValue}
                  />
                ))}
            </>
          )}

          {locations.find((loc) => loc.code === "withdraw") && (
            <Input
              inputAttr={{
                type: "radio",
              }}
              name="typeFreight"
              label={`${selectValue ? "" : "- "}Retirada na loja: ${
                withDrawValue === 0 && labelFree
                  ? labelFree
                  : floatToPriceWithoutSpace(withDrawValue)
              }`}
              checked={typeFreight === "withdraw"}
              change={() => {
                setTypeFreight("withdraw");
                setFreightFind(withDrawValue);
                setWithdrawLocation();
              }}
              showRadio={selectValue}
            />
          )}
        </>
      )}
    </div>
  );
};

export { ChooseAddress };
